import {
    Box,
    Button,
    Card,
    CardContent,
    Grid,
    MenuItem,
    Select,
    Skeleton,
    Typography,
} from '@mui/material';
import React, { useState } from 'react';
import OccupancyChart from '../../components/Dashboard/Occupancy/Experience/OccupancyChart';
import { Period } from '../../enums/reports';
import { useNavigate, useParams } from 'react-router';
import { useGetIndividualAssetQuery } from '../../../app/Slices/SevenDayApiSlice';
import { NavigateBefore } from '@mui/icons-material';
import ExperiencePreview from '../../components/Dashboard/Occupancy/Experience/ExperiencePreview';
import UserRole from '../../../shared/AuthRoles';
import WeeklyChart from '../../components/Dashboard/Occupancy/Experience/WeeklyChart';
import SmallStats from '../../components/Dashboard/Occupancy/SmallStats';

const ExperienceOccupancyReport = () => {
    const loggedInUser = UserRole();
    const [period, setPeriod] = useState(Period.CurrentMonth);

    const { id } = useParams();
    const navigate = useNavigate();

    const { data: experience, isFetching } = useGetIndividualAssetQuery(
        `/owners/${loggedInUser?.company}/modules/${id}`,
        {
            skip: !id || !loggedInUser,
        },
    );

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    pb: 1,
                }}
            >
                {experience ? (
                    <Typography variant='h1'>{experience?.name}</Typography>
                ) : (
                    <Skeleton width={400} />
                )}
                <Select
                    value={period}
                    onChange={(e) => setPeriod(e.target.value as Period)}
                >
                    <MenuItem value={Period.CurrentWeek}>This Week</MenuItem>
                    <MenuItem value={Period.CurrentMonth}>This Month</MenuItem>
                    <MenuItem value={Period.PreviousMonth}>Last Month</MenuItem>
                    <MenuItem value={Period.CurrentYear}>This Year</MenuItem>
                </Select>
            </Box>
            <Grid container spacing={2}>
                <Grid item xs={12} lg={4}>
                    <ExperiencePreview experience={experience} />
                </Grid>
                <SmallStats
                    period={period}
                    module={experience?.id}
                    moduleLoading={isFetching}
                />
                <Grid item xs={12} lg={8}>
                    <OccupancyChart period={period} module={experience?.id} />
                </Grid>
                <Grid item xs={12} lg={4}>
                    <WeeklyChart period={period} module={experience?.id} />
                </Grid>
            </Grid>
            <Button
                startIcon={<NavigateBefore />}
                onClick={() => navigate('/reports/occupancy')}
            >
                Back to Occupancy
            </Button>
        </>
    );
};

export default ExperienceOccupancyReport;
